import './index.css';
import { bootstrap } from './bootstrap';

void bootstrap(document.getElementById('root')!);
